var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightNarrow = function SvgArrowRightNarrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M15.94 6.94a1.5 1.5 0 0 1 2.121 0l4 4q.105.106.19.231l.018.03q.068.108.117.228l.019.05q.016.042.03.086a2 2 0 0 1 .036.144c.038.193.038.39 0 .583q-.008.037-.018.072-.007.036-.018.07-.014.045-.03.088l-.019.048a1.5 1.5 0 0 1-.117.228l-.019.03a1.5 1.5 0 0 1-.189.233l-4 4a1.5 1.5 0 0 1-2.121-2.121l1.44-1.44H3a1.5 1.5 0 0 1 0-3h14.38l-1.44-1.44a1.5 1.5 0 0 1 0-2.12"
  })));
};
export default SvgArrowRightNarrow;